import React from 'react';
import lwLogo from '../../assets/lw-logo.svg';

// Renders the real reference logo (static/images/Logov2.svg).
export function Logo({ className = '', alt = 'LeaseCheck Logo', ...imgProps }) {
  return <img src={lwLogo} alt={alt} className={className} {...imgProps} />;
}

export default Logo;
